import { render, staticRenderFns } from "./TextRecommendationEmpty.vue?vue&type=template&id=15c3ce9d&scoped=true"
import script from "./TextRecommendationEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationEmpty.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationEmpty.vue?vue&type=style&index=0&id=15c3ce9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3ce9d",
  null
  
)

export default component.exports